import { render } from "./NotFoundPage.vue?vue&type=template&id=5f4cdddc&scoped=true&ts=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"

import "./NotFoundPage.vue?vue&type=style&index=0&id=5f4cdddc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4cdddc"]])

export default __exports__